import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-bootstrap';

export default function CustomSwitch(props) {
  const {value, ...filteredProps} = props
  return <Form.Switch {...filteredProps} checked={value} style={{display: 'inline-block'}}/>
}

CustomSwitch.propTypes = {
  value: PropTypes.bool.isRequired
}
